import * as React from "react";
import { SVGProps } from "react";
export const CaretRightIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M9.83301 12.688C9.55567 12.9653 9.23634 13.031 8.87501 12.885C8.51367 12.7397 8.33301 12.4653 8.33301 12.062V7.958C8.33301 7.56933 8.51367 7.302 8.87501 7.156C9.23634 7.01067 9.55567 7.07667 9.83301 7.354L11.875 9.396C11.9583 9.47933 12.0243 9.57666 12.073 9.688C12.1217 9.79866 12.146 9.90966 12.146 10.021C12.146 10.1323 12.1217 10.2433 12.073 10.354C12.0243 10.4653 11.9583 10.5627 11.875 10.646L9.83301 12.688Z"
            fill="currentColor"
        />
    </svg>
);
CaretRightIcon.displayName = "CaretRightIcon";
